import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { clone, isEmpty, isEqual, isObject, merge, transform } from 'lodash';

export enum JSONType {
  formJSON = 0,
  originalJSON = 1,
  other = 2,
}

@Component({
  selector: 'app-json-editor',
  templateUrl: './json.editor.component.html',
  styleUrls: ['../pages/configuration.component.css'],
})
export class JsonEditorComponent implements OnInit {
  private readonly VALID_JSON_MSG = 'Formato JSON Correcto';
  public JSONTypeEnum = JSONType;

  @ViewChild('includeDiff') includeDifferences: MatSlideToggle;
  @Input() formJSON: any;
  @Input() originalJSON: any;
  @Output() JSONData: EventEmitter<any> = new EventEmitter<any>();

  originalDifferences: any = {};
  formDifferences: any = {};

  validJSONmsg: string = this.VALID_JSON_MSG;
  validJSON: boolean = true;

  ngOnInit(): void {
    this.updateDifferences();
  }

  private updateDifferences(): void {
    this.originalDifferences = this.getDifferences(this.originalJSON, this.formJSON);
    this.formDifferences = this.getDifferences(this.formJSON, this.originalJSON);
  }

  validateJSON(event: any, type: JSONType) {
    if (event.key === 'Tab') {
      event.preventDefault();
      const value: string = event.target.value;
      const start: number = event.target.selectionStart;
      const end: number = event.target.selectionEnd;
      event.target.value = value.substring(0, start) + '\t' + value.substring(end);
      event.target.selectionStart = event.target.selectionEnd = start + 1;
    }

    let json = event.target?.value;

    try {
      let newJSON = JSON.parse(json);
      this.validJSONmsg = this.VALID_JSON_MSG;
      this.validJSON = true;
      if (type === JSONType.formJSON) this.formJSON = newJSON;
      if (type === JSONType.originalJSON) this.originalJSON = newJSON;
      this.updateDifferences();
    } catch (error) {
      this.validJSONmsg = error.message;
      this.validJSON = false;
    }
  }

  hasDifferences(object: any): boolean {
    return !isEmpty(object);
  }

  saveJSON() {
    let result: any = this.buildJSON(this.includeDifferences.checked);
    this.JSONData.emit(result);
  }

  private buildJSON(includeDifferences: boolean): any {
    if (includeDifferences) return merge(this.formJSON, this.originalDifferences);
    return clone(this.formJSON);
  }

  private getDifferences(object: any, base: any) {
    return transform(object, (result: any, value: any, key: any) => {
      if (!isEqual(value, base[key])) {
        result[key] = isObject(value) && isObject(base[key]) ? this.getDifferences(value, base[key]) : value;
      }
    });
  }
}
